<template>
    <ion-page>
        <ion-header>
            <ion-toolbar>
                <ion-buttons slot="end">
                    <ion-button @click="close()">
                        <ion-icon slot="icon-only" :icon="closeOutline"></ion-icon>
                    </ion-button>
                </ion-buttons>
                <ion-title>Shipment: {{ shipment.reference }}</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content :fullscreen="true">
            <ion-list>
                <ion-item lines="none">
                    <ion-label>
                        <h2>{{ item.name }}</h2>
                        <p>{{ item.item_number }}</p>
                    </ion-label>
                </ion-item>
            </ion-list>
            <div class="ion-padding">

                <table>
                    <thead>
                    <tr>
                        <th style="width:1%"></th>
                        <th></th>
                        <th v-for="field in fields" :key="field">
                            <ion-checkbox v-model="selectedColumns[field]" />
                        </th>
                        <th></th>
                    </tr>
                    <tr>
                        <th></th>
                        <th>Box</th>
                        <th>Qty</th>
                        <th>W<small>cm</small></th>
                        <th>L<small>cm</small></th>
                        <th>H<small>cm</small></th>
                        <th>W<small>kg</small></th>
                        <th>P</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="box in shippingData.boxes" :key="box.box.id">
                        <td>
                            <ion-checkbox v-model="selectedBoxes[box.box.id]" />
                        </td>
                        <td>{{ box.box.number }}</td>
                        <td>{{ box.quantity }}</td>
                        <td>{{ box.box.width_cm }}</td>
                        <td>{{ box.box.length_cm }}</td>
                        <td>{{ box.box.height_cm }}</td>
                        <td>{{ box.box.total_weight_kg }}</td>
                        <td>
                            <span v-if="shipment.is_pallets">
                            {{ box.box.pallet }}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>GT</td>
                        <td>{{ shippingData.boxes.length }}</td>
                        <td>{{ totalBoxed }}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>{{ totalWeight }}</td>
                        <td></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </ion-content>
        <ion-footer>
            <ion-toolbar>
                <ion-button fill="outline" expand="block" color="primary" :disabled="!editable" @click="edit()">Edit Selected</ion-button>
            </ion-toolbar>
        </ion-footer>
    </ion-page>
</template>

<script>
import {alertController} from '@ionic/vue';
import {closeOutline} from 'ionicons/icons';
import {
    IonContent, IonPage, IonLabel, IonItem, IonHeader, IonToolbar,
    IonTitle, IonButtons, IonIcon, IonList, IonButton, IonFooter,
    IonCheckbox
} from '@ionic/vue';
import _ from 'lodash';
import EventBus from "@/EventBus";

export default {
    props: {shipment: Object, line: Object, shippingData: Object},
    inject: ['$http', '$toast', '$validationAlert'],
    emits: ['updated', 'close'],
    name: 'ShipmentLineBoxesDetail',
    components: {
        IonContent, IonPage, IonHeader, IonToolbar,
        IonTitle, IonButtons, IonButton, IonIcon,
        IonLabel, IonItem, IonList, IonFooter,
        IonCheckbox
    },
    computed: {
        totalBoxed() {
            return _.sum(_.map(this.shippingData.boxes, 'quantity'));
        },
        totalWeight() {
            return _.sum(_.map(this.shippingData.boxes, 'box.total_weight_kg'));
        },
        columnsToEdit() {
            const columns = [];
            for (const name in this.selectedColumns) {
                if (this.selectedColumns[name]) {
                    columns.push(name);
                }
            }
            return columns;
        },
        boxes() {
            if (!this.shippingData && this.shippingData.boxes) {
                return [];
            }
            return _.filter(this.shippingData.boxes, box => {
                return Object.keys(this.selectedBoxes).indexOf(box.box.id.toString()) >= 0;
            });
        },
        dialogTitle() {
            const prefix = 'Edit Box';
            const list = _.map(this.boxes, 'box.number').join(', ');
            return `${prefix}# ${list}`;
        },
        editable() {
            return _.filter(this.selectedBoxes).length > 0 && Object.keys(this.selectedColumns).length > 0;
        },
        fields() {
             return ['quantity', 'width_cm', 'length_cm', 'height_cm', 'total_weight_kg', 'pallet'];
        },
        item() {
            if (this.line && this.line.item) {
                return this.line.item;
            }
            return {};
        }
    },
    methods: {
        edit() {
            const columnList = _.map(this.columnsToEdit, column => {
                return column.replace(/_/g, ' ');
            }).join(', ');

            return alertController.create({
                header: this.dialogTitle,
                subHeader: 'Update : ' + columnList,
                backdropDismiss: false,
                inputs: _.map(this.columnsToEdit, column => {
                    return {
                        placeholder: column.replace(/_/g, ' '),
                        type: 'number',
                        name: column
                    };
                }),
                buttons: [{
                    role: 'cancel',
                    text: 'Cancel',
                }, {
                    role: 'save',
                    text: 'Save',
                    handler: values => {
                        return this.save(values);
                    }
                }]
            }).then(alert => alert.present());
        },
        close() {
            this.$emit('close');
        },
        save(values) {
            const payload = {
                boxes: Object.keys(this.selectedBoxes),
                values: values
            };
            EventBus().emitter.emit('loading', true);
            return this.$http.put(`/api/checks/lines/${this.line.id}/boxes`, payload).then(() => {
                this.$emit('updated');
                this.close();
                this.$toast.success("Box plan updated");
            }).catch(error => {
                this.$validationAlert(error);
            }).finally(() => {
                EventBus().emitter.emit('loading', false);
            });
        }
    },
    data() {
        return {
            selectedColumns: {},
            selectedBoxes: {}
        }
    },
    setup() {
        return {
            closeOutline
        };
    }
}
</script>
<style>
table td, table th {
    text-align: center;
}
</style>
